import cns from 'classnames';
import Link from 'next/link';
import { XIcon } from '@zep/icons';
import { GNBMenu, GNBSubMenu } from '../../../types';
import S from './Header.module.scss';
import { HeaderCTAButton, Logos } from './HeaderCommons';
import { ServiceMenuIcon } from './ServiceMenuIcon';

/**
 * @param MobileGNBMenuProps
 * @returns 모바일 헤더 메뉴 컴포넌트
 */
const MobileGlobalNavigationBarMenu = (props: MobileGNBMenuProps) => {
  const {
    headerContent,
    setIsShow,
    isShow
  } = props;
  return <nav className={cns(S.mobile_nav, isShow && S.show_mobile_nav)} data-sentry-component="MobileGlobalNavigationBarMenu" data-sentry-source-file="MobileGlobalNavigationBarMenu.tsx">
      <div className={S.mobile_header}>
        {<Logos />}
        <button className={S.close_button} onClick={() => setIsShow(!isShow)}>
          <XIcon aria-label="Close" data-sentry-element="XIcon" data-sentry-source-file="MobileGlobalNavigationBarMenu.tsx" />
        </button>
      </div>
      <div className={S.mobile_contents}>
        {headerContent.map((menu: GNBMenu) => <div className={cns(S.mobile_menu, menu.menus && S.mobile_menu_sub)} key={menu.title}>
            {menu.menus ? <div className={S.mobile_menu_mini}>{menu.title}</div> : <Link href={(menu.useBaseURL && process.env.NEXT_PUBLIC_BASE_URL || '') + menu.path} target={menu.target} onClick={() => setIsShow(!isShow)} prefetch={false}>
                {menu.title}
              </Link>}

            {menu.menus && <>
                <div className={cns(S.mobile_subMenu, menu.variant === 'service' && 'flex-col')}>
                  {menu.menus.filter((menus: GNBSubMenu) => !menus.hidden).map((menus: GNBSubMenu) => <Link key={menus.name} href={(menus.useBaseURL && process.env.NEXT_PUBLIC_BASE_URL || '') + menus.url} target={menus.target} rel={menus.target === '_blank' ? 'noopener noreferrer' : undefined} aria-label={menus.newTabLabel ? `${menus.name} (${menus.newTabLabel})` : undefined} className={menu.variant === 'service' ? '!h-auto !min-h-[48px] !w-full !justify-start !gap-xs !space-x-0 !p-xs text-body-md-medium !font-medium' : undefined} onClick={() => setIsShow(!isShow)} prefetch={false}>
                        {menu.variant === 'service' ? <span className="shrink-0 p-[2px]" aria-hidden="true">
                            <ServiceMenuIcon name={menus.name} />
                          </span> : <img width={18} height={18} src={menus.icon} alt="sub menu icon" />}
                        <span>{menus.name}</span>
                      </Link>)}
                </div>
                <span className={S.contour_line}></span>
              </>}
          </div>)}
      </div>
      <div className={S.mobile_footer}>
        <HeaderCTAButton data-sentry-element="HeaderCTAButton" data-sentry-source-file="MobileGlobalNavigationBarMenu.tsx" />
      </div>
    </nav>;
};
export default MobileGlobalNavigationBarMenu;
type MobileGNBMenuProps = {
  headerContent: GNBMenu[];
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
};